import qs from 'qs'

const fields = [
  'title',
  'date_time_start',
  'date_time_end',
]

export const queryProgramEntryBySlug = (options: QueryBySlugOrIdOptions) => {
  const searchKey = strapiGetI18nSlug(options.locale)

  const query = qs.stringify(
    {
      publicationState: options?.publicationState || 'live',
      filters: {
        slugs: {
          [searchKey]: {
            $eq: options.slug
          }
        }
      },
      fields,
      populate: {
        ...queryFragmentCollectionTypeDefault,
        ...queryFragmentBlocks,
        opening_date_time: true,
        cover_image: true,
        introductions: true,
        tags: true,
        date_time_ranges: true,
        program_entry: thumbnailProgramEntry,
        program_entries: thumbnailProgramEntry,
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `program-entries?${query}`
}
